import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const HPCBatch = () => {

    const [batchList, setBatchList] = useState<any[]>([]);
    const [coachList, setCoachList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [programList, setProgramList] = useState<any[]>([]);
    const [geoList, setGeoList] = useState<any[]>([]);
    const [hpcList, setHpcList] = useState<any[]>([]);
    const [batchName, setBatchName] = useState('');
    const [coachId, setCoachId] = useState('');
    const [sportId, setSportId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [geoId, setGeoId] = useState('');
    const [hpcId, setHpcId] = useState('');
    const [programId, setProgramId] = useState('');
    const [batchStatus, setBatchStatus] = useState('');
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchBatch() {
            setIsLoading(true);
            const batchResponse = await func.hpcBatch(null);
            setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
            setIsLoading(false);
        }
        fetchBatch();
    }, [])

    const filteredData = batchList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>;
    };

    const coachNameRender = (rowData) => {
        return <span>{rowData.coachName}</span>;
    };

    const sportsNameRender = (rowData) => {
        return <span>{rowData.sportsName}</span>;
    };

    const progNameRender = (rowData) => {
        return <span>{rowData.programName}</span>;
    };

    const batchStatusRender = (rowData) => {
        return <span>{(rowData.batchStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editBatch(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const btchId = rowData.batchId;
        return (
            <Link to="#" onClick={() => deleteBatch(btchId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    async function newBatch() {
        setIsEdit(false)
        setOpenModal(true)
        setBatchName('')
        setSportId('')
        setCoachId('')
        setGeoId('')
        setHpcId('')
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
    }

    async function editBatch(rowData: { batchId: string | number; }) {
        const btchId = rowData.batchId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.hpcBatch(btchId);
        setBatchId(getDetails.batchId);
        setBatchName(getDetails.batchName);
        setHpcId(getDetails.geoHPCId);
        setCoachId(getDetails.coachId);
        setSportId(getDetails.sportId);
        setProgramId(getDetails.programId);
        setBatchStatus(getDetails.batchStatus);
        const geoResponse = await func.listGeoStates();
        setGeoList(Array.isArray(geoResponse) ? geoResponse : []);
        const cochResponse = await func.getCoachesByHpc(hpcId);
        setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
        const sprtResponse = await func.getSportsByCoach(coachId);
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const progResponse = await func.program(null);
        setProgramList(Array.isArray(progResponse) ? progResponse : [])
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateBatch();
            } else {
                if (batchName && coachId && sportId) {
                    const formData = new FormData();
                    formData.append("geoHPCId", hpcId);
                    formData.append("name", batchName);
                    formData.append("coachId", coachId);
                    formData.append("sportId", sportId);
                    formData.append("programId", programId);

                    const createBatch = api.HPCBatch;
                    fetch(createBatch, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateBatch() {
        const formData = new FormData();
        formData.append("geoHPCId", hpcId);
        formData.append("name", batchName);
        formData.append("coachId", coachId);
        formData.append("sportId", sportId);
        formData.append("programId", programId);
        formData.append("status", batchStatus);

        const updatebtch = api.HPCBatch + '/' + batchId;
        fetch(updatebtch, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteBatch(btchId: string) {
        const deleteBatch = api.HPCBatch + '/' + btchId + '/' + 0;
        fetch(deleteBatch, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>HPC Batch</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newBatch() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Batch">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="coachName"
                                                header="Coach Name"
                                                body={coachNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="sportName"
                                                header="Sport Name"
                                                body={sportsNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="programName"
                                                header="Program Name"
                                                body={progNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchStatus"
                                                header="Batch Status"
                                                body={batchStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="lg"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Batch</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="row">
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">State Name</label>
                                            <Select
                                                value={geoList.find(state => state.geographyId === geoId) ? {
                                                    value: geoId,
                                                    label: geoList.find(state => state.geographyId === geoId).geographyName
                                                } : null}
                                                onChange={async (e) => {
                                                    setGeoId(e.value);
                                                    const hpcResponse = await func.getHpcByGeography(e.value);
                                                    setHpcList(Array.isArray(hpcResponse) ? hpcResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select State"
                                                options={geoList.map(state => ({
                                                    value: state.geographyId,
                                                    label: state.geographyName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={hpcList.find(hpc => hpc.geoHPCId === hpcId) ? {
                                                    value: hpcId,
                                                    label: hpcList.find(hpc => hpc.geoHPCId === hpcId).geoHPCName
                                                } : null}
                                                onChange={async (e) => {
                                                    setHpcId(e.value);
                                                    const cochResponse = await func.getCoachesByHpc(e.value);
                                                    setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Center"
                                                options={hpcList.map(hpc => ({
                                                    value: hpc.geoHPCId,
                                                    label: hpc.geoHPCName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Coach Name</label>
                                            <Select
                                                value={coachList.find(coch => coch.userId === coachId) ? {
                                                    value: coachId,
                                                    label: coachList.find(coch => coch.userId === coachId).coachName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCoachId(e.value);
                                                    const sprtResponse = await func.getSportsByCoach(e.value);
                                                    setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Coach"
                                                options={coachList.map(coch => ({
                                                    value: coch.userId,
                                                    label: coch.coachName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Sport Name</label>
                                            <Select
                                                value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                    value: sportId,
                                                    label: sportList.find(sprt => sprt.sportId === sportId).sportsName
                                                } : null}
                                                onChange={async (e) => {
                                                    setSportId(e.value);
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Sport"
                                                options={sportList.map(sprt => ({
                                                    value: sprt.sportId,
                                                    label: sprt.sportsName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Program Level</label>
                                            <Select
                                                value={programList.find(prog => prog.programId === programId) ? {
                                                    value: programId,
                                                    label: programList.find(prog => prog.programId === programId).programName
                                                } : null}
                                                onChange={async (e) => {
                                                    setProgramId(e.value);
                                                }}
                                                required
                                                styles={customSelect}
                                                placeholder="Select Program"
                                                options={programList.map(prog => ({
                                                    value: prog.programId,
                                                    label: prog.programName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Batch Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="batchname"
                                                placeholder="Enter Batch Name"
                                                required
                                                value={batchName}
                                                onChange={(e) => setBatchName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    {isEdit ?
                                        <>
                                            <div className="row">
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <label className="form-label">Status</label>
                                                </div>
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={batchStatus === '1'}
                                                            id="geoBatchStatus"
                                                            onChange={(e) => {
                                                                setBatchStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </> : null
                                    }
                                </div>
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal >
                )
            }
        </>
    )
}

export default HPCBatch;